import React from 'react'

const CurrentOffers = () => (
  <div className="current-offers-container">
    <div className='text-container white'>
      <h3 className="mb-4">Our current loan offers</h3>
      <p>We consider your time, your circumstances and your wallet. Discover the best rate for you</p>
    </div>
    <div className='button-container'>
      <a className="btn btn-xl btn-white mr-4 apply-now-button" href='/pages/our-rates'>
        View rates
      </a>
      <a className="btn btn-xl mr-sm-2 talk-to-expert-btn-grey-hover" href='/onboarding_funnel/new'>
        Apply now
      </a>
    </div>
  </div>
);

export default CurrentOffers
